import { render, staticRenderFns } from "./EModalSelectMonthAulaEletiva.vue?vue&type=template&id=61946afc&scoped=true"
import script from "./EModalSelectMonthAulaEletiva.vue?vue&type=script&lang=js"
export * from "./EModalSelectMonthAulaEletiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61946afc",
  null
  
)

export default component.exports